import { useQuery } from '@vue/apollo-composable'
import { computed } from 'vue'
import { graphql } from '@/gql'
import { ComplianceName } from '@/gql/graphql'
import activeCompliances from '@/components/Hire/HirePageCompliance/activeCompliances'

export function useComplianceGate(hireId: string, gateName: ComplianceName) {
  const { result: gateResult, loading: gateLoading } = useQuery(
    graphql(`
      query HireGateQuery($id: ID!, $gateName: ComplianceName!) {
        gate(id: $id, gate: $gateName) {
          title
          actor
          description
          applicable
          completed
          name
          compliances {
            ...ComplianceAlert
          }
        }
      }
    `),
    () => ({
      id: hireId,
      gateName,
    }),
    {
      clientId: 'publicApi',
    },
  )

  const gate = computed(() => gateResult.value?.gate)
  const loading = computed(() => gateLoading.value)

  // Get active compliances from the gate
  const active = computed(() => {
    if (!gate.value?.compliances) return []
    return activeCompliances(gate.value.compliances)
  })

  const completed = computed(() => gate.value?.completed)

  return {
    gate,
    loading,
    active,
    completed,
  }
}
